var _path, _path2, _path3;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCheckEngine = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#FEF9EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.276 21.224H31.173L28.966 17.914H25.104V15.707H29.518V13.5H18.484V15.707H22.898V17.914H19.036L16.829 21.224H13.519V25.087H11.312V21.222H9.103L8 22.878V24.534L9.103 26.19V31.156H11.31V27.295H13.517V31.156H16.827L19.034 34.467H32.276V21.224ZM21.793 31.707L22.896 26.741H19.586L26.206 20.672L25.103 25.638H28.413L21.793 31.707Z",
    fill: "#F8B131"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8969 22.3271H37.2409V25.6381H35.0339V21.2241H33.3789V34.4661H35.0339V31.1551V28.9481H37.2409V33.3621H38.8969L39.9999 32.2591V23.4311L38.8969 22.3271Z",
    fill: "#F8B131"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckEngine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check-engine.47776da3.svg";
export { ForwardRef as ReactComponent };